module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA6.304971c1.jpg";